import { render, staticRenderFns } from "./PressTable.vue?vue&type=template&id=6cffe4ec&scoped=true&"
import script from "./PressTable.vue?vue&type=script&lang=js&"
export * from "./PressTable.vue?vue&type=script&lang=js&"
import style0 from "./PressTable.vue?vue&type=style&index=0&id=6cffe4ec&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cffe4ec",
  null
  
)

export default component.exports